/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Drop_FrameInputs */



/**
* | output |
* | --- |
* | "Source Drop Frame" |
*
* @param {Source_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_drop_frame = /** @type {((inputs?: Source_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drop frame source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelle Drop Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Origine Drop Frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходный кадр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fotograma a eliminar de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源丢帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースドロップフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत ड्रॉप फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro de origem")
	return /** @type {LocalizedString} */ ("Source Drop Frame")
});